var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('left-sidebar'),_c('div',{staticClass:"page-wrapper py-0 position-relative",class:{'closed-sidebar': !_vm.isOpen}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }